import * as React from 'react';
export const terminalSvg = React.forwardRef(function terminalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.5 8.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.75 1a.75.75 0 0 0 0 1.5H3V13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2.5h1.25a.75.75 0 0 0 0-1.5H1.75Zm9.75 1.5h-1v11h.5a.5.5 0 0 0 .5-.5V2.5Zm-7 0H9v11H5a.5.5 0 0 1-.5-.5V2.5Z',
    }),
  );
});
terminalSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var terminal = {
  category: 'icon',
  colorable: true,
  name: 'terminal',
  svg: terminalSvg,
};
